import * as ScreenOrientation from "expo-screen-orientation";
import { useEffect, useState } from "react";

const orientations = {
  0: "UNKNOWN",
  1: "PORTRAIT_UP",
  2: "PORTRAIT_DOWN",
  3: "LANDSCAPE_LEFT",
  4: "LANDSCAPE_RIGHT",
} as const;

type Orientation = (typeof orientations)[keyof typeof orientations];

/**
 * Getter for orientation e.g.
 *
 *
 * const { orientation } = useScreenOrientation();
 *
 * if (orientation.includes("LANDSCAPE")) {
 *   // Do something for landscape orientation
 * }
 *
 *
 * It does NOT actually write to orientation, only reads it for other
 * components to use.
 *
 * @returns {Object} - An object containing the current orientation.
 */
export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<Orientation>(orientations[0]);

  useEffect(() => {
    const fetchInitialOrientation = async () => {
      try {
        const currentOrientation =
          await ScreenOrientation.getOrientationAsync();
        const resolved = orientations[currentOrientation];
        if (resolved && resolved !== "UNKNOWN") {
          setOrientation(resolved);
        }
      } catch (e) {
        console.log("Error getting initial orientation", e);
      }
    };

    fetchInitialOrientation();

    const subscription = ScreenOrientation.addOrientationChangeListener(
      (event) => {
        const resolved = orientations[event.orientationInfo.orientation];
        setOrientation(resolved);
      }
    );

    return () =>
      ScreenOrientation.removeOrientationChangeListener(subscription);
  }, []);

  return { orientation };
};
